// UUIDv7 generator. PostHog's sessions table (which backs Web Analytics) keys on
// `$session_id` and extracts the session start time from the embedded v7
// timestamp — a v4 id (crypto.randomUUID) is not time-ordered and won't bucket
// correctly. So we mint our own v7 ids for sessions/windows rather than pull in
// a dependency.
//
// Layout (RFC 9562): 48-bit unix_ts_ms | 4-bit version | 12-bit rand | 2-bit
// variant | 62-bit rand.
export const uuidv7 = (): string => {
  const bytes = new Uint8Array(16)
  const ts = Date.now()

  // 48-bit big-endian millisecond timestamp in bytes 0..5. Division (not >>>)
  // because the value exceeds 32 bits and bitwise ops would truncate it.
  for (let i = 0; i < 6; i++) {
    bytes[5 - i] = Math.floor(ts / 2 ** (8 * i)) % 256
  }

  crypto.getRandomValues(bytes.subarray(6))
  bytes[6] = (bytes[6] & 0x0f) | 0x70 // version 7
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // variant 10

  const hex: string[] = []
  for (let i = 0; i < 16; i++) {
    hex.push(bytes[i].toString(16).padStart(2, '0'))
  }
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
}
